import { render, staticRenderFns } from "./ReportePromediosCantidad.vue?vue&type=template&id=665c20ec&scoped=true"
import script from "./ReportePromediosCantidad.vue?vue&type=script&lang=js"
export * from "./ReportePromediosCantidad.vue?vue&type=script&lang=js"
import style0 from "./ReportePromediosCantidad.vue?vue&type=style&index=0&id=665c20ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c20ec",
  null
  
)

export default component.exports